<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          class="mr-1"
          small
          color="primary"
          dark
          v-on="{ ...tooltip }"
          v-on:click="onOpen"
        >
          <v-icon>mdi-swap-horizontal</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("kiosks.changeDevice") }}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <v-card width="800">
        <v-card-title>
          <span class="headline">{{ $t("kiosks.changeDevice") }}</span>
        </v-card-title>
        <v-card-text style="overflow-y: auto;  max-height: 400px">
          <v-container>
            <v-col cols="12" sm="12" md="12">
              {{ $t("referenceBooks.banks.Name") }} :
              {{ selectedKiosk.bankName }}
            </v-col>
            <v-col cols="12" sm="12" md="12">
              {{ $t("referenceBooks.branches.Name") }} :
              {{ selectedKiosk.branchName }}
            </v-col>
            <v-col cols="12" sm="12" md="12">
              {{ $t("kiosks.kioskName") }} : {{ selectedKiosk.kioskName }}
            </v-col>
            <ComboboxDevs v-model="selectedKiosk.deviceId" :items="avDevices" />
            <small class="mr-4 ml-4"
              >*{{ $t("referenceBooks.requiredFields") }}</small
            >
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">{{
            $t("Close")
          }}</v-btn>
          <v-btn color="blue darken-1" text @click="save">{{
            $t("Save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>
<script>
import DragForm from '@/components/Forms/DragForm.vue';
import ComboboxDevs from '@/components/Kiosks/DevicesComboboxDialog';
import { notifyError, notifySuccess } from '@/services/notifications';
import Vue from 'vue';

export default {
  components: {
    DragForm,
    ComboboxDevs,
  },
  props: {
    selectedKiosk: {
      type: Object,
      defaultItem: null,
    },
  },
  data() {
    return {
      dialog: false,
      avDevices: [],
    };
  },
  watch: {},
  methods: {
    async onOpen() {
      await this.setAvailableDevices();
      if (this.avDevices === null || this.avDevices.length === 0) {
        this.showMessage(
          this.$t('Error'),
          `${this.$t('kiosks.notAvailableDevs')}`,
          'error'
        );

        return;
      } else this.dialog = !this.dialog;
    },
    async setAvailableDevices() {
      await this.$axios.kiosks
        .getAvailableDevices(this.selectedKiosk.kioskId)
        .then((response) => response.data)
        .then((json) => {
          this.avDevices = json;
        })
        .catch((error) => {
          console.error(error);

          notifyError('', 'Error get available devices');
          this.catchErrors(error);
        });
    },
    close() {
      this.dialog = false;
      this.$emit('close');
    },
    async save() {
      const data = [this.selectedKiosk.deviceId];

      await this.$axios.kiosks
        .changeDevice(this.selectedKiosk.kioskId, data)
        .then(() => {
          this.success = true;
          notifySuccess(
            '',
            this.$t('kiosks.wasRepinnedToKiosk', [
              this.selectedKiosk.kioskName,
              this.selectedKiosk.deviceName,
            ])
          );
        })
        .catch((error) => {
          this.success = false;
          notifyError('', this.$t('Error'));
          console.error(error);
          this.$emit('error', error);
        });

      this.dialog = false;
    },
    showMessage(title, text, type = '') {
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
  },
};
</script>
